import { Injectable } from '@angular/core';
import { GlobalServiceProvider } from './global-service';

@Injectable()
export class ImpostosServiceProvider {

    constructor(public global: GlobalServiceProvider) {

    }

    //-------------------------------------------------------------------
    /*/{WmsMais.doc} getImposto
    Método retorna o imposto do produto
    @author Kenny Roger Martins
    @since 13/02/2018
    /*/
    //-------------------------------------------------------------------
    getImposto(pedido, produto, zero) {

        let nImposto: number = 0;
        let nMVA: number = 0;
        let nPerDes: number = 0;
        let nAliqInt: number = 0;
        let nAliqExt: number = 0;
        let nPMC: number = parseFloat(produto.B1_YPMC17);
        let nPreco: number = parseFloat(produto.C6_PRCVEN);
        let nPMPF: number = parseFloat(produto.B1_YPRECON);
        let lPMPF: boolean = this.global.getParamametro('PMPF_ES');

        if (produto.B1_CEST !== '') {

            switch (pedido.C5_CLIENTE.CLI_ESTADO) {
                case 'ES':

                    if (lPMPF) {
                        nMVA = parseFloat(produto.B1_YMVAES);
                    } else {
                        nMVA = parseFloat(produto.YD_YNCMES);
                    }

                    nAliqInt = 17;
                    nAliqExt = 7;

                    switch (produto.B1_TPPROD) {
                        case '0':
                            nPerDes = 75;
                            break;
                        case '1':
                            nPerDes = 75;
                            break;
                        case '2':
                            nPerDes = 15;
                            break;
                    }

                    break;
                case 'BA':
                    nMVA = parseFloat(produto.YD_YNCMBA);
                    nAliqInt = 17;
                    nAliqExt = 7;
                    break;
                case 'MG':
                    nMVA = parseFloat(produto.YD_YNCMMG);
                    nAliqInt = 18;
                    nAliqExt = 12;
                    break;
                case 'RJ':
                    nMVA = parseFloat(produto.YD_YNCMRJ);
                    nAliqInt = 0;
                    nAliqExt = 0;
                    break;
            }

            if (!lPMPF && nPMC > 0) {
                nImposto = this.doCalcA(nAliqInt, nAliqExt, nPMC, nPerDes, nPreco);
            } else if (lPMPF && nPMPF > 0) {
                nImposto = this.doCalcD(nAliqInt, nAliqExt, nPMPF, nPreco);
            } else if (nMVA > 0) {
                nImposto = this.doCalcB(nAliqInt, nAliqExt, nMVA, nPreco);
            }

        }

        if (pedido.C5_CLIENTE.CLI_ESTADO == "RJ") {
            nImposto = nPreco * 0.05;
        }

        if (zero) {
            nImposto += (nImposto > 0 ? nPreco : 0);
        } else {
            nImposto += nPreco;
        }

        return nImposto.toFixed(2);

    }

    doCalcA(nAliqInt, nAliqExt, nPMC, nPerDes, nPreco) {

        let nIcmsRet: number = 0;
        let nDesconto: number = 0;
        let nBaseCalc: number = 0;
        let nCredICms: number = 0;

        nDesconto = nPMC * nPerDes / 100;
        nBaseCalc = nPMC - nDesconto;
        nIcmsRet = nBaseCalc * nAliqInt / 100;
        nCredICms = nPreco * nAliqExt / 100;
        nIcmsRet = nIcmsRet - nCredICms;

        if (nIcmsRet < 0) {
            nIcmsRet = 0;
        }

        return nIcmsRet

    }

    doCalcB(nAliqInt, nAliqExt, nMVA, nPreco) {

        let nIcmsRet: number = 0;
        let nICMS: number = 0;
        let nBCST: number = 0;

        nICMS = nPreco * nAliqExt / 100;
        nBCST = nPreco + (nPreco * nMVA / 100);
        nIcmsRet = (nBCST * nAliqInt / 100) - nICMS;

        return nIcmsRet

    }

    doCalcD(nAliqInt, nAliqExt, nPMPF, nPreco) {

        let nICMS: number = 0;

        nICMS = ((nPMPF * nAliqInt / 100) - (nPreco * nAliqExt / 100));

        return nICMS;

    }

    //-------------------------------------------------------------------
    /*/{WmsMais.doc} getPF
    Método retorna preço fábrica
    @author Kenny Roger Martins
    @since 13/02/2018
    /*/
    //-------------------------------------------------------------------
    getPF(pedido, produto) {

        let nPreco: string;

        switch (pedido.C5_CLIENTE.CLI_ESTADO) {
            case 'ES':
                nPreco = produto.VM_ABCFARMA[0].VM_PF;
                break;
            case 'BA':
                nPreco = produto.VM_ABCFARMA[1].VM_PF;
                break;
            case 'MG':
                nPreco = produto.VM_ABCFARMA[2].VM_PF;
                break;
            case 'RJ':
                nPreco = produto.VM_ABCFARMA[3].VM_PF;
                break;
            default:
                nPreco = produto.VM_ABCFARMA[3].VM_PF;
                break;
        }

        return parseFloat(nPreco).toFixed(2);

    }

    //-------------------------------------------------------------------
    /*/{WmsMais.doc} getPMC
    Método retorna o PMC
    @author Kenny Roger Martins
    @since 13/02/2018
    /*/
    //-------------------------------------------------------------------
    getPMC(pedido, produto) {

        let nPreco: string;

        switch (pedido.C5_CLIENTE.CLI_ESTADO) {
            case 'ES':
                nPreco = produto.VM_ABCFARMA[0].VM_PMC;
                break;
            case 'BA':
                nPreco = produto.VM_ABCFARMA[1].VM_PMC;
                break;
            case 'MG':
                nPreco = produto.VM_ABCFARMA[2].VM_PMC;
                break;
            case 'RJ':
                nPreco = produto.VM_ABCFARMA[3].VM_PMC;
                break;
            default:
                nPreco = produto.VM_ABCFARMA[3].VM_PMC;
                break;
        }

        return parseFloat(nPreco).toFixed(2);

    }

    //-------------------------------------------------------------------
    /*/{WmsMais.doc} getDesc
    Método retorna o desconto sobre PF
    @author Kenny Roger Martins
    @since 13/02/2018
    /*/
    //-------------------------------------------------------------------
    getDesc(pedido, produto) {

        let nPreco: number = parseFloat(this.getPF(pedido, produto));
        let nDesc: number = (nPreco - parseFloat(produto.C6_PRCVEN)) * 100 / nPreco;

        if (nPreco <= 0) {
            nDesc = 0;
        }

        if (nDesc < 0) {
            nDesc = 0;
        }

        return nDesc.toFixed(2);

    }

}



// WEBPACK FOOTER //
// ./src/providers/impostos-service.ts